import $ from 'jquery';

$('body').on('click', '.filter__toggle', function () {
    const filterControls = $(this).closest('.filter').find('.filter-controls');
    filterControls.toggleClass('filter-controls--visible-all');
    $(this).text(filterControls.hasClass('filter-controls--visible-all') ? $(this).attr('data-hide') : $(this).attr('data-show'));
});
